



























































import {isMaxLengthRuleBroken} from '@/shared';
import SelectNewsImageModal from '@/components/admin-panel/news/SelectNewsImageModal.vue';
import {Size} from '@/models/admin-panel';
import {Actions} from '@/store';
import {resetModel, ToastsService} from '@/utils';
import Vue from 'vue';
import {quillEditor} from 'vue-quill-editor';
import {AddNews, News} from '@/models/dashboard';
import {TranslateResult} from 'vue-i18n';

export default Vue.extend({
  name: 'AddNewsModal',
  components: {
    quillEditor,
    SelectNewsImageModal,
  },
  props: {
    news: Object as () => News,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      modalTitle: null as unknown as TranslateResult,
      form: {
        isKudoNews: true,
        title: '',
        content: '',
        iconFile: null as unknown as Blob,
        iconFileData: '',
        url: '',
        imageData: {
          width: 125,
          height: 125,
        } as Size,
      },
      editorData: '',
      isFileFormatInvalid: false,
      editorOption: {
        placeholder: this.$t('feedback.editor-placeholder'),
        modules: {
          toolbar: [
            [
              {size: ['small', false, 'large']},
            ],
            ['bold', 'italic'],
            [
              {list: 'ordered'},
              {list: 'bullet'},
            ],
            ['image'],
            [
              {align: []},
            ],
          ],
        },
      },
    };
  },
  methods: {
    areErrorMessagesDisplayed(field: string): boolean {
      return isMaxLengthRuleBroken(this, field);
    },
    resetForm() {
      this.form = resetModel(this.form);
      this.form.iconFile = null as unknown as Blob;
      this.form.isKudoNews = true;
      this.form.url = '';
      this.form.imageData = {
        width: 125,
        height: 125,
      };
    },
    async setNews() {

      if (!this.news) {
        this.modalTitle = this.$t('admin-panel.news.add-modal.title');
        return;
      }

      this.modalTitle = this.$t('admin-panel.news.edit-modal.title');
      this.form = {
        title: this.news.title,
        isKudoNews: this.news.isKudoNews,
        content: this.news.content,
        iconFile: await this.getBlob(this.news.imageUrl),
        iconFileData: null as unknown as string,
        url: this.news.imageUrl,
        imageData: {
          width: 125,
          height: 125,
        } as Size,
      };
    },
    async saveNews() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;

      if (this.form.url) {
        await this.saveRegularNews();
      } else {
        await this.saveKudoNews();
      }
    },
    hideModal() {
      this.$bvModal.hide('add-news-modal');
      this.$emit('refresh');
      this.resetForm();
    },
    async saveRegularNews() {
      try {
        const reader = new FileReader();

        reader.readAsDataURL(this.form.iconFile);
        reader.onloadend = async () => {
          try {
            const model = {
              isKudoNews: this.form.isKudoNews,
              title: this.form.title,
              content: this.form.content,
              languageCode: this.$i18n.locale,
            } as AddNews;

            if (!this.form.isKudoNews) {
              const base64data = (reader.result as string).split(',')[1];
              model.imageData = {
                bytes: base64data,
                imageType: this.form.iconFile.type.split('/')[1],
              };
            }

            if (this.news) {
              const newsId = this.news.id;
              await this.$store.dispatch(Actions.news.editNews, {id: newsId, news: model});
            } else {
              await this.$store.dispatch(Actions.news.addNews, model);
            }
            ToastsService.success(this.$t('admin-panel.news.add-modal.news-saved-toast') as string);

            this.hideModal();
          } finally {
            this.loader.isRequestPending = false;
          }
        };
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    async saveKudoNews() {
      try {
        const model = {
          isKudoNews: this.form.isKudoNews,
          title: this.form.title,
          content: this.form.content,
          imageData: null,
          languageCode: this.$i18n.locale,
        };

        if (this.news) {
          const newsId = this.news.id;
          await this.$store.dispatch(Actions.news.editNews, {id: newsId, news: model});
        } else {
          await this.$store.dispatch(Actions.news.addNews, model);
        }
        ToastsService.success(this.$t('admin-panel.news.add-modal.news-saved-toast') as string);
        this.hideModal();
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    validateImage(data: any) {
      const path = data.quill.editor.delta.ops;

      this.isFileFormatInvalid = path.some((el: any) => el.insert.image && !el.insert.image.startsWith('data:image/'));
    },
    openUploadModal() {
      this.$bvModal.show('select-news-image-modal');
    },
    async onNewsImageSelected(value: Promise<Blob>) {
      const blob = await value;

      this.form.iconFile = blob;
      this.form.url = URL.createObjectURL(blob);
    },
    async getBlob(imageUrl: string): Promise<Blob> {
      if (!imageUrl) {
        return null as unknown as Blob;
      }

      return (this.form.iconFile = await fetch(imageUrl).then(r => r.blob()));
    },
  },
});
